import Chip from '@/components/ui/chips/chip';
import { SelectOption } from '@/components/ui/select/select.interface';
import { ILibraryTenantAttributeFilters } from '@/lib/fragments/libraryTenantAttributeFilters';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

interface AttributeFilterProps {
  attributes: ILibraryTenantAttributeFilters;
  handleGiftCardChange: Dispatch<SetStateAction<SelectOption>>;
  handleLoyaltyCardChange: Dispatch<SetStateAction<SelectOption>>;
  handleOfferChipChange: Dispatch<SetStateAction<SelectOption>>;
  handleMemberDayCardChange: Dispatch<SetStateAction<SelectOption>>;
  activeAttributionFilterValue: string | undefined;
}

const AttributeFilter = ({
  attributes,
  handleGiftCardChange,
  handleLoyaltyCardChange,
  handleOfferChipChange,
  handleMemberDayCardChange,
  activeAttributionFilterValue,
}: AttributeFilterProps) => {
  const [selectedAttributionFilter, setSelectedAttributionFilter] = useState<
    string | undefined
  >(activeAttributionFilterValue);

  const onAttributionFilterChange = (attribute: string, value: string) => {
    const defaultValues = { optionText: value, optionValue: value };
    if (selectedAttributionFilter === value) {
      setSelectedAttributionFilter(undefined);
    } else {
      setSelectedAttributionFilter(value);
    }

    if (attribute == 'giftCard') {
      handleGiftCardChange(defaultValues);
    } else if (attribute == 'loyaltyCard') {
      handleLoyaltyCardChange(defaultValues);
    } else if (attribute == 'memberDay') {
      handleMemberDayCardChange(defaultValues);
    } else {
      handleOfferChipChange(defaultValues);
    }
  };

  return (
    <>
      {attributes?.offerPageAvailable && (
        <Chip
          key={attributes.offerPageLabel}
          label={attributes.offerPageLabel}
          value={attributes.offerPageLabel}
          className={
            selectedAttributionFilter == attributes.offerPageLabel
              ? 'border-black-500 border-2'
              : ''
          }
          chipOnClick={() => {
            onAttributionFilterChange('offer', attributes.offerPageLabel);
          }}
        />
      )}

      {attributes?.giftCardLabel && attributes?.giftCardAvailable && (
        <Chip
          key={attributes.giftCardLabel}
          label={attributes.giftCardLabel}
          value={attributes.giftCardLabel}
          className={
            selectedAttributionFilter == attributes.giftCardLabel
              ? 'border-black-500 border-2'
              : ''
          }
          chipOnClick={() => {
            onAttributionFilterChange('giftCard', attributes.giftCardLabel);
          }}
        />
      )}

      {attributes?.loyaltyCardLabel && attributes?.loyaltyCardAvailable && (
        <Chip
          key={attributes.loyaltyCardLabel}
          label={attributes.loyaltyCardLabel}
          value={attributes.loyaltyCardLabel}
          className={
            selectedAttributionFilter == attributes.loyaltyCardLabel
              ? 'border-black-500 border-2'
              : ''
          }
          chipOnClick={() => {
            onAttributionFilterChange(
              'loyaltyCard',
              attributes.loyaltyCardLabel,
            );
          }}
        />
      )}

      {attributes?.memberDayCardLabel && attributes?.memberDayCardAvailable && (
        <Chip
          key={attributes.loyaltyCardLabel}
          label={attributes.memberDayCardLabel}
          value={attributes.memberDayCardLabel}
          className={
            selectedAttributionFilter == attributes.memberDayCardLabel
              ? 'border-black-500 border-2'
              : ''
          }
          chipOnClick={() => {
            onAttributionFilterChange(
              'memberDay',
              attributes.memberDayCardLabel,
            );
          }}
        />
      )}
    </>
  );
};

export default AttributeFilter;
